import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { ProdutoAgregado } from '../modelo/produto-agregado';
import { BraConfirmComponent } from '../componentes/bra-confirm/bra-confirm.component';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Config } from '../services/config';
import { ExtratoContratoService } from '../services/extratocontrato.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { CancelamentoProdutosAgregadosService } from '../services/cancelamento-produtos-agregados.service';
import { EnderecoContrato } from '../modelo/enderecoContrato';
import { Contrato } from '../modelo/contrato';
import { CancelamentoProdutosResponse, CancelarProdutoResponse } from '../modelo/cancelamento-produtos-response';
import { CancelarProdutoModalDadosBancariosComponent, DadosBancariosCancelamento } from './cancelar-produto-modal-dados-bancarios.component';
import { Response } from '@angular/http';
import { finalize, timeout } from 'rxjs/operators';

declare var $ :any;

@Component({
  selector: 'app-cancelar-produto-agregado',
  templateUrl: './cancelar-produto-agregado.component.html',
  styleUrls: ['./cancelar-produto-agregado.component.css'],
  providers: [ExtratoContratoService, MensagemService, RestClientService, CancelamentoProdutosAgregadosService]
})
export class CancelarProdutoAgregadoComponent extends AbstractComponent implements OnInit {

  listaProdutosAgregados: ProdutoAgregado[] = [];
  produtoSelecionado: ProdutoAgregado = new ProdutoAgregado();
  enderecoContrato: EnderecoContrato = new EnderecoContrato();
  contratoList: Contrato[] = [];
  carregandoProdutos: boolean = true;
  exibirMensagemVazia: boolean = false;
  etapaAtual: number = 1;
  // mapeia o número de contrato enviado no payload (sem o último dígito) para o número completo exibido na tela
  private mapaContratoCompleto: { [contratoSemDigito: string]: string } = {};

  constructor(
    private spinnerService: Ng4LoadingSpinnerService,
    private sessaoService: SessaoService,
    private extratoContratoService: ExtratoContratoService,
    private mensagemService: MensagemService,
    private cancelamentoProdutosService: CancelamentoProdutosAgregadosService,
    private router: Router,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  ngOnInit() {
    // Menu
    $(".btsMenu .btn").removeClass("active activeDrop");
    $(".cancelarproduto").addClass("active");

    //Scroll top
    window.scrollTo(0,0);

    // Chama o endpoint para listar contratos
    this.buscaContratos();
    // A busca de produtos agregados é chamada após obter os contratos

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  /**
   * Retorna a lista de contratos
   */
  buscaContratos = (): void => {
    this.extratoContratoService.listarContrato().subscribe(
      (result: EnderecoContrato) => {
        this.enderecoContrato = result;
        if (result.cdMsgemRetorno === '00') {
          this.contratoList = result.listaContrato;
          this.sessao.autenticado.nuCpfCnpjFormatado = result.nuCpfCnpjFormatado;
          
          this.mapaContratoCompleto = {};
          const numerosContratos = this.contratoList.map(c => {
            const contratoCompleto = c.nuContrato.toString();
            const contratoSemDigito = contratoCompleto.slice(0, -1);
            this.mapaContratoCompleto[contratoSemDigito] = contratoCompleto;
            return contratoSemDigito;
          });
          this.carregandoProdutos = true;
          this.exibirMensagemVazia = false;
          
          // Define um timeout de 2 segundos para exibir a mensagem caso não haja produtos
          setTimeout(() => {
            if (this.carregandoProdutos === false && this.listaProdutosAgregados.length === 0) {
              this.exibirMensagemVazia = true;
            }
          }, 2000);
          
          this.carregarProdutosAgregados(numerosContratos);
        } else if (result.cdMsgemRetorno === '1007') {
          this.carregandoProdutos = false;
          this.exibirMensagemVazia = false;
          this.spinnerService.hide();
          this.sair();
        } else {
          this.carregandoProdutos = false;
          this.exibirMensagemVazia = false;
          this.spinnerService.hide();
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.carregandoProdutos = false;
        this.exibirMensagemVazia = false;
        this.spinnerService.hide();
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      }
    );
  }

  /**
   * Carrega a lista de produtos agregados disponíveis para cancelamento
   * @param contratos - Lista de números de contratos
   */
  carregarProdutosAgregados(contratos: string[]): void {
    this.cancelamentoProdutosService.buscarProdutosAgregados(contratos).subscribe(
      (result: CancelamentoProdutosResponse) => {
        // Transforma a resposta em objetos ProdutoAgregado para exibição
        this.listaProdutosAgregados = [];
        
        if (result && result.length > 0) {
          result.forEach(contratoComProdutos => {
            if (contratoComProdutos.produtos && contratoComProdutos.produtos.length > 0) {
              contratoComProdutos.produtos.forEach(produtoDetalhes => {
                const produto = new ProdutoAgregado();
                produto.cdProduto = produtoDetalhes.codigoProduto;                
                produto.nuContrato = this.mapaContratoCompleto[contratoComProdutos.numeroContrato] || contratoComProdutos.numeroContrato;
                produto.nmProduto = produtoDetalhes.nomeProduto;
                produto.dtContratacaoFormatada = produtoDetalhes['data-inicio-seguro'];
                produto.vrMensalFormatado = '-';
                produto.dsStatus = 'Ativo';
                
                this.listaProdutosAgregados.push(produto);
              });
            }
          });
        }
        
        this.carregandoProdutos = false;

        // Se não houver produtos após o carregamento, aguarda timeout para exibir mensagem
        if (this.listaProdutosAgregados.length === 0) {
          setTimeout(() => {
            this.exibirMensagemVazia = true;
          }, 2000);
        }
        
        this.spinnerService.hide();
      },
      (error: Response) => {
        console.error('Erro ao buscar produtos agregados:', error);
        this.carregandoProdutos = false;
        this.exibirMensagemVazia = false;
        this.spinnerService.hide();
        this.dialog.open(BraAlertComponent, {
          width: Config.POPUP_50VW,
          data: {
            mensagem: 'Erro ao buscar produtos agregados. Tente novamente mais tarde.'
          }
        });
      }
    );
  }

  selecionarProduto(produto: ProdutoAgregado): void {
    if (produto.solicitado) {
      return;
    }

    this.produtoSelecionado = produto;
    this.etapaAtual = 1;

    this.abrirModalConfirmacao();
  }

  abrirModalConfirmacao(): void {
    const dialogRef = this.dialog.open(BraConfirmComponent, {
      width: Config.POPUP_50VW,
      data: {
        mensagem: 'Deseja cancelar esse Produto Agregado?'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Sim') {
        this.abrirModalDadosBancarios();
      }      
    });
  }
  
  abrirModalDadosBancarios(): void {
    const dialogRef = this.dialog.open(CancelarProdutoModalDadosBancariosComponent, {
      width: Config.POPUP_35VW
    });

    dialogRef.afterClosed().subscribe((dadosBancarios: DadosBancariosCancelamento) => {
      if (dadosBancarios) {
        this.confirmarCancelamento(dadosBancarios);
      }      
    });
  }

  confirmarCancelamento(dadosBancarios: DadosBancariosCancelamento): void {
    const contratoSemDigito = this.produtoSelecionado.nuContrato.toString().slice(0, -1);

    this.cancelamentoProdutosService.cancelarProduto(
      contratoSemDigito,
      this.produtoSelecionado.cdProduto,
      dadosBancarios
    ).pipe(
      timeout(10000),
      finalize(() => this.spinnerService.hide())
    ).subscribe(
      (result: CancelarProdutoResponse) => {
        this.produtoSelecionado.solicitado = true;
        this.etapaAtual = 2;
        this.exibirModalSucesso(result ? result.mensagem : '');
      },
      (error: Response) => {
        console.error('Erro ao cancelar produto:', error);

        let mensagem = 'Erro ao cancelar o produto. Tente novamente mais tarde.';
        if (error && error.status === 409) {
          try {
            const corpoErro = error.json();
            mensagem = (corpoErro && corpoErro.apierro && corpoErro.apierro.mensagem) || mensagem;
          } catch (e) {
            // Mantém a mensagem padrão caso o corpo do erro não seja um JSON válido
          }
        }

        this.dialog.open(BraAlertComponent, {
          width: Config.POPUP_50VW,
          data: {
            mensagem: mensagem
          }
        });
      }
    );
  }

  exibirModalSucesso(mensagemRetorno?: string): void {
    const mensagem = (mensagemRetorno ? '<b>' + mensagemRetorno + '</b> ' : '')
      + 'A empresa responsável vai entrar em contato com você para seguir com o cancelamento e o pagamento do reembolso.';

    const dialogRef = this.dialog.open(BraAlertComponent, {
      width: Config.POPUP_50VW,
      data: {
        mensagem: mensagem,
        erro: false,
        sucesso: true
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      // Mantém o card marcado como solicitado e a barra de progresso na etapa de conclusão
    });
  }

  /**
   * Efetua o logout do sistema e redireciona para o autoline
   */
  sair() {
    sessionStorage.removeItem("sessao");
    sessionStorage.clear();
    this.sessaoService.sessao.logado = false;
    this.router.navigate(['/redirecionamento']);
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-cancelarproduto-cli/cancelar-produto-agregado.component.ts